export default __webpack_public_path__ + "static/media/both-directions.fffe7dbc.svg";